import { isFormValid } from '../../../../library/Core/SmartFunctions';
import { DispatchEvent, State } from '../../../../library/Core/SmartTypes';
import StudentService from '../../../../services/student.service';

export const handleNext = (
    event: React.SyntheticEvent<HTMLButtonElement>,
    state: State,
    dispatch: (dispatchEvent: DispatchEvent) => void,
    globalState: any,
    globalDispatch: (dispatchEvent: DispatchEvent) => void,
    sessionState: any,
    sessionDispatch: (dispatchEvent: DispatchEvent) => void
) => {
    event.preventDefault();

    const isImpersonatedSession = sessionStorage.getItem('is-impersonated-session') === 'YES';

    const certificationsRaw = state?.data?.['certifications'] ?? [];
    if (!isImpersonatedSession && certificationsRaw.length === 0) {
        alert('Please add at least one certification before submitting.');
        return;
    }

    if (!isImpersonatedSession && !isFormValid(state, dispatch)) {
        alert('Please correct the form errors!');
        return;
    }

    const certificationsRawFiltered = certificationsRaw.filter((cert: any) => {
        return cert.title || cert.issuingOrganization || cert.issueDate || cert.expiryDate || cert.credentialId || cert.credentialUrl || cert.description || cert.pdfStorageUrl;
    });

    const certifications = certificationsRawFiltered.map((cert: any) => {
        const today = new Date();
        const expiry = cert.expiryDate ? new Date(cert.expiryDate) : null;
        const status = expiry && expiry < today ? 'EXPIRED' : (cert.status ?? 'ACTIVE');
        return { ...cert, status };
    });
    
    if (certifications.length === 0) {
        alert('Please add at least one active certification before submitting.');
        return;
    }

    StudentService.pageSave(
        state.routeInfo.id,
        state.routeInfo.pageName,
        StudentService.toStudentEntity({ id: state.routeInfo.id, certifications })
    ).then(() => {
        state.actions['ROUTER_NAVIGATE'](`/alumni/${state.routeInfo.id}/profile/certifications`);
    });
};

export const handleCompleteLater = (state: State, dispatch: (dispatchEvent: DispatchEvent) => void) => {
    document.getElementsByClassName('modal').item(0)?.setAttribute('style', 'display:block');
};
